module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Welcome":"Willkommen bei profiControl"},"en":{"Welcome":"Welcome at profiContol"}}')
  delete Component.options._Ctor
}
